import { ReactNode } from "react";
import { SortButtonContainer } from "./SortButton.elements";
import { ChevronDown } from "icons/indexed-icons/IconChevronDown";

export const SortButton = ({
    children,
    IconUp,
    IconDown,
    className,
    asc,
    desc,
    handleClick,
    direction,
    dataSets,
    styles
}:{
    children?: ReactNode,
    IconUp?: JSX.Element,
    IconDown?: JSX.Element,
    className?: string,
    asc?: boolean,
    desc?: boolean,
    styles?: Record<string, string>,
    dataSets?:Record<string, string>,
    direction?: string
    handleClick?: () => string
}): JSX.Element => {
    
   
    className = `sort-button ${className || ''}`.trim()
    if (direction === 'ASC') {
        asc = true
        desc = false
    } else if (direction === 'DESC') {
        asc = false
        desc = true
    }
    if (asc) className += ' asc'
    else if (desc) className += ' desc'
    if (IconUp || IconDown) className += ' has-icons'
    
    IconUp = IconUp || <ChevronDown className='up' />
    IconDown = IconDown || <ChevronDown className='down' />

    return (
        <SortButtonContainer className={className} style={styles} {...(dataSets || {})} onClick={() => handleClick?.(children as string)}>
            <span className='label'>{children}</span>
            {IconUp}
            {IconDown}
        </SortButtonContainer>
    )
}